
import { Component, Mixins } from 'vue-property-decorator';
import CommonTargetChart from '@/components/common/CommonTargetChart.vue';
import CommonRankName from '@/components/common/CommonRankName.vue';
import CommonLoading from '@/components/common/CommonLoading.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import { SingleRankMixin } from '@/utils/mixin';
@Component({
  components: {
    CommonTargetChart,
    CommonRankName,
    CommonRankNumber,
    CommonLoading,
  },
})
export default class SingleBuy extends Mixins(SingleRankMixin) {
  created() {
    this.domIndex = 3;
    this.refName = 'singlebuy';
  }
}
